/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["contact-widget{display:block;text-align:center;padding:25px;margin-top:45px}contact-widget .icon{width:40px;height:40px;color:rgba(0,0,0,.5)}contact-widget .title{font-size:2rem;margin-bottom:10px;line-height:24px}contact-widget .subtitle{font-size:1.6rem;margin-bottom:25px;line-height:23px}"];
export { styles as styles };
